import { getSessionUUID } from '../components/lib/AuthToken';
import logger from '../utils/logger';

const apiRequest = async (method, path, body = null) => {
    try {
        const sessionToken = await getSessionUUID();
        const options = {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        };
        if (body) options.body = JSON.stringify(body);

        const response = await fetch(`/messages${path}`, options);
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error(`Messages API error [${method} ${path}]:`, err);
        return { status: 500, data: { error: err.message } };
    }
};

export const getConversations = () =>
    apiRequest('GET', '/conversations');

export const getOrCreateConversation = (other_profile_id) =>
    apiRequest('POST', '/conversations', { other_profile_id });

export const getMessages = (conversation_id) =>
    apiRequest('GET', `/conversations/${conversation_id}/messages`);

export const sendMessage = (conversation_id, body) =>
    apiRequest('POST', '/send', { conversation_id, body });

export const editMessage = (message_id, body) =>
    apiRequest('PUT', `/msg/${message_id}/edit`, { body });

export const deleteConversation = (conversation_id) =>
    apiRequest('DELETE', `/conversations/${conversation_id}`);

export const deleteMessage = (message_id) =>
    apiRequest('DELETE', `/msg/${message_id}`);
